import GoogleButton from "./google-auth/GoogleButton";

interface SocialAuthProps {
  variant?: "default" | "header";
}

const SocialAuth = ({ variant = "default" }: SocialAuthProps) => {
  if (variant === "header") {
    return (
      <div className="flex items-center">
        <GoogleButton variant="header" />
      </div>
    );
  }

  return (
    <div className="flex w-full items-center justify-center gap-2">
      <GoogleButton />
    </div>
  );
};

export default SocialAuth;
